<!-- <div class="card"> -->
<div class="flex sm:flex-row flex-column">
  <div class="sm:col-4 hidden sm:inline-block">
    <img [src]="moduleDetails.image" alt="Premium Feature" style="width: 100%; height: auto" />
  </div>
  <div class="sm:col-8 col-12">
    <h2>Unlock {{ moduleDetails.title }} Feature!</h2>
    <ul>
      <li *ngFor="let feature of moduleDetails?.features">
        <i class="pi pi-check-circle text-green-500 mr-2"></i>
        {{ feature }}
      </li>
    </ul>
    <p class="text-small">Subscribe now to unlock the full potential of our platform.</p>
    <button
      pButton
      icon="pi pi-verified"
      label="Subscribe Now"
      styleClass="p-button-success w-9 btn-active"
      [routerLink]="['/app/settings/organization-settings/subscriptions']"
    ></button>
    <!-- p-button-outlined -->
  </div>
</div>
<!-- </div> -->
